// import $ from 'jquery';
import React from 'react'
import Field from './Field'
import { isEmail } from 'validator'
// import PropTypes from 'prop-types';

class FieldEmail extends Field {
  constructor(props) {
    super(props)
  }
  // format(value) {
  // }
  validate() {
    const { value } = this.props
    return super.validate() && isEmail(value)
  }
  render() {
    const { label, animatedLabel } = this.props

    return (
      <label className={this.handleClasses()} data-label={animatedLabel} ref={(r) => (this.field = r)}>
        {super.renderLabel()}
        {super.renderAutoresize()}
        <input className="field__input" ref={(r) => (this.input = r)} {...super.generateProps()} type="email" />
        {super.renderError()}
      </label>
    )
  }
}

export default FieldEmail
